<template>
  <div class="action-bar">
    <btn-style :btn-list="btnList" class="btn-list-style"></btn-style>
    <div class="title-bar">
      <div class="title-icon">
        <img :src="robotImg" class="ai-chat-img" />
      </div>
      <div class="title">
        <div class="name">CBaaS AI助理</div>
        <div class="des">基于语言大模型的人工智能问答助手</div>
      </div>
      <div class="fill"></div>
      <el-select v-model="model" placeholder="切换模型" size="medium">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import robotImg from '@/assets/images/chatrobot/robot-title.png'
export default {
  name: 'ActionBar',
  data() {
    return {
      model: null,
      options: [],
      robotImg,
      btnList: [
        {
          isFill: true
        },
        {
          btnContent: '',
          click: () => {
            return this.onBack()
          },
          type: 'text',
          icon: 'icon-clear'
        }
      ]
    }
  },
  watch: {
    model: function(value) {
      this.$emit('onModelChanged', value)
    }
  },
  methods: {
    onBack() {
      this.$emit('onBack')
    },
    getModelOptions() {
      let self = this
      this.$apis.chatrobot
        .getModel()
        .then(result => {
          if (result && result.code == 200 && result.object && result.object.length > 0) {
            self.options = result.object.map((e, index) => {
              return {
                value: e,
                label: `大模型${index + 1}`
              }
            })
            self.model = self.options[0].value
            self.$emit('onModelChanged', this.model)
          } else {
            self.genDefaultOptions()
          }
        })
        .catch(err => {
          console.log(err)
          self.genDefaultOptions()
          self.$message.warning('获取模型信息出错，请检查您的网络！')
        })
    },
    genDefaultOptions() {
      this.options = []
      this.model = null
      this.$emit('onModelChanged', this.model)
    },
    init() {
      this.getModelOptions()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'action-bar',
  (
    --title-bar-background-color: rgba(255, 255, 255, 0.19),
    --title-bar-border-color: rgba(255, 255, 255, 0.17),
    --title-des-color: var(--base-color-text-regular)
  ),
  (
    --title-bar-background-color: rgba(255, 255, 255, 0.19),
    --title-bar-border-color: rgba(255, 255, 255, 0.17),
    --title-des-color: var(--base-color-text-placeholder)
  )
);

.action-bar {
  @include adaptation(
    (
      --title-bar-height: 78px,
      --title-icon-width: 82px,
      --title-img-size: 134px,
      --title-img-left: -50px,
      --title-img-top: -67px,
      --title-select-width: 136px,
      --close-btn-icon-size: 28px,
      --actions-margin-bottom: 22px
    )
  );
  display: flex;
  flex-direction: column;

  .btn-list-style {
    /deep/ {
      .el-button {
        color: var(--base-color-white);

        &:hover,
        &:active {
          color: var(--base-color-notice);
        }

        .btn-content {
          .btn-icon {
            font-size: var(--close-btn-icon-size);
          }
        }
      }
    }

    margin-bottom: var(--actions-margin-bottom);
    margin-right: var(--base-size-24);
  }

  .title-bar {
    display: flex;
    background-color: var(--title-bar-background-color);
    border: var(--base-border-width) solid var(--title-bar-border-color);
    border-radius: calc(var(--title-bar-height) / 2);
    height: var(--title-bar-height);
    align-items: center;
    padding: 0 var(--base-size-32) 0;

    .title-icon {
      position: relative;
      width: var(--title-icon-width);

      .ai-chat-img {
        position: absolute;
        width: var(--title-img-size);
        height: var(--title-img-size);
        left: var(--title-img-left);
        top: var(--title-img-top);
      }
    }

    .title {
      .name {
        color: var(--base-color-white);
        font-size: var(--base-font-size-large);
        margin-bottom: var(--base-size-4);
        line-height: var(--base-size-24);
      }

      .des {
        color: var(--title-des-color);
        font-size: var(--base-font-size-common);
        line-height: var(--base-size-16);
      }
    }

    .el-select {
      /deep/ {
        .el-input__inner {
          border-radius: var(--base-size-16);
          height: var(--base-size-32);
          line-height: var(--base-size-32);
          width: var(--title-select-width);
        }

        .el-input__suffix {
          right: 0;

          .el-input__suffix-inner {
            .el-input__icon {
              line-height: var(--base-size-32);
            }
          }
        }
      }
    }
  }

  .fill {
    flex-grow: 1;
  }
}
</style>
